// RUTA: src/components/support/TicketCreatedListener.tsx
//
// Listener global que escucha el evento custom `iftmx:ticket-created`
// y muestra el modal TicketCreatedDialog con el número del ticket
// recién creado. Esto permite que cualquier parte del sistema dispare
// la confirmación con un dispatchEvent() en vez de tener que importar
// el modal y manejar su estado localmente.
//
// Usado por toastError() y futuras integraciones (ej. errores
// reportados desde service worker, push handlers, etc.)

import { useEffect, useState } from 'react';
import { TicketCreatedDialog } from './TicketCreatedDialog';
import type { TicketPriority } from '@/lib/supportSla';

interface TicketCreatedEvent extends CustomEvent {
  detail: { ticket_number: string; priority?: TicketPriority };
}

export function TicketCreatedListener() {
  const [open, setOpen] = useState(false);
  const [ticketNumber, setTicketNumber] = useState<string | null>(null);
  const [priority, setPriority] = useState<TicketPriority | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const ev = e as TicketCreatedEvent;
      const num = ev.detail?.ticket_number;
      if (num) {
        setTicketNumber(num);
        setPriority(ev.detail?.priority ?? null);
        setOpen(true);
      }
    };
    window.addEventListener('iftmx:ticket-created', handler);
    return () => window.removeEventListener('iftmx:ticket-created', handler);
  }, []);

  return (
    <TicketCreatedDialog
      open={open}
      onOpenChange={setOpen}
      ticketNumber={ticketNumber}
      priority={priority}
    />
  );
}
